// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1C_HF","rightAdornment":"Header_rightAdornment__3VDJY"};